export const PEOPLE_SETTINGS_URL = '/people';
export const REQUEST_TYPES_SETTINGS_URL = '/settings/request-types';
export const EMAIL_SETTINGS_URL = '/settings/email';
export const CHAT_SETTINGS_URL = '/settings/chat';
export const PORTAL_SETTINGS_URL = '/settings/portal-settings';
